module.exports = MINT;